// extracted by mini-css-extract-plugin
export default {"list-desc":"list-desc_Jz5ylMuo","toggle-desc":"toggle-desc_eRdtUmwK"};